const Theme = {
  colors: {
    colorOne: "#000814",
    colorTwo: "#001D3D",
    colorThree: "#001020",
    colorFour: "#FF6600",
    colorFive: "#FFC300",
    colorSix: "#076ED1",
    txtBaseColor: "#ffffff",
    txtDesColor: "#ccc",
  },
  fonts: {
    logoFont: "Silkscreen",
    txtFont: "Roboto Flex",
  },
};

export { Theme };
